import {Component, ChangeDetectionStrategy} from '@angular/core';
import {SnackbarService} from "../../../services/snackbar/snackbar.service";
import { NgClass } from "@angular/common";

@Component({
  selector: 'app-snackbar',
  imports: [
    NgClass
],
  templateUrl: './snackbar.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './snackbar.component.scss'
})
export class SnackbarComponent {

  constructor(
    private snackbarService: SnackbarService
  ) {
  }

  getMessages(): any[] {
    return this.snackbarService.getMessages();
  }

  close(message: any): void {
    this.snackbarService.close(message);
  }

  hasData(message: any): boolean {
    if (message.type === 'success') {
      return false;
    }

    if (Array.isArray(message.data) && message.data.length === 0) {
      return false;
    }

    return message.data !== null;
  }

  getData(message: any): string {
    return JSON.stringify(message.data, null, 2);
  }
}
